import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Grid } from 'app/components/ui/Grid'
import { useLocationFields } from 'app/hooks/useLocationFields'
import { Location } from 'EstraSponsor'
import React from 'react'
import { useFormContext } from 'react-hook-form'

type Props = {
  locations: Location[]
}

export const ContactsFormSection = ({ locations }: Props): JSX.Element => {
  const { watch } = useFormContext()

  const provinceIdWatcher = watch('company_province_id')

  const { provinceOptions, cityOptions } = useLocationFields({
    locations,
    selectedProvinceId: provinceIdWatcher,
    provincesOnly: true,
  })

  return (
    <>
      <Grid cols={[8, 2, 2]}>
        <FormGroup>
          <SmartInput
            label='Indirizzo sede legale'
            name='company_address_street'
            labelRequired
          />
        </FormGroup>
        <FormGroup>
          <SmartInput
            label='Civico'
            name='company_address_number'
            labelRequired
          />
        </FormGroup>

        <FormGroup>
          <SmartInput label='CAP' name='company_postal_code' labelRequired />
        </FormGroup>
      </Grid>
      <Grid cols={[6, 6]}>
        <FormGroup>
          <SmartInput
            type='select'
            label='Provincia'
            name='company_province_id'
            labelRequired
            selectCaretSize='small'
          >
            <option value={''}>Seleziona</option>
            {provinceOptions.map((province) => (
              <option key={province.value} value={province.value}>
                {province.label}
              </option>
            ))}
          </SmartInput>
        </FormGroup>

        <FormGroup>
          <SmartInput
            type='select'
            label='Comune'
            name='company_city_id'
            labelRequired
            selectCaretSize='small'
            disabled={!cityOptions.length}
          >
            <option value={''}>Seleziona</option>
            {cityOptions.map((city) => (
              <option key={city.value} value={city.value}>
                {city.label}
              </option>
            ))}
          </SmartInput>
        </FormGroup>
      </Grid>
      <Grid cols={[6, 6]}>
        <FormGroup>
          <SmartInput
            textPrefix='+39'
            label='Telefono'
            name='company_phone_number'
            labelRequired
          />
        </FormGroup>

        <FormGroup>
          <SmartInput
            textPrefix='+39'
            label='Cellulare'
            name='company_mobile_number'
            labelRequired
          />
        </FormGroup>
      </Grid>

      <Grid cols={[6, 6]}>
        <FormGroup>
          <SmartInput textPrefix='+39' label='Fax' name='company_fax_number' />
        </FormGroup>
        <FormGroup>
          <SmartInput type='email' label='PEC' name='company_pec' />
        </FormGroup>
      </Grid>
    </>
  )
}
